import { value } from '@takeshape/util';
import { updateAuthentication } from "../util/authentication.js";
import { hasEveryKey } from "../util/has.js";
import { getHealthCheck } from "../util/health.js";
const serviceProvider = {
    name: 'contentful',
    title: 'Contentful',
    description: "Contentful's platform helps teams deliver digital experiences faster with an API-first approach.",
    categories: ['content'],
    links: [{ title: 'Homepage', url: 'https://www.contentful.com/' }],
    serviceType: 'graphql',
    introspectionType: 'graphql',
    createId: value('contentful'),
    getFormSchema: value({
        type: 'object',
        properties: {
            id: {
                title: 'Slug',
                type: 'string',
                pattern: '[0-9A-Za-z_-]+',
                default: 'contentful'
            },
            title: {
                title: 'Name',
                type: 'string',
                default: 'Contentful'
            },
            namespace: {
                title: 'Namespace',
                type: 'string',
                pattern: '^[A-Z][A-Za-z]+$',
                default: 'Contentful'
            },
            space: {
                title: 'Contentful Space ID',
                type: 'string'
            },
            environment: {
                title: 'Contentful Environment ID',
                type: 'string'
            },
            authentication: {
                title: 'Authentication',
                type: 'object',
                properties: {
                    token: {
                        title: 'Contentful Content Delivery API Access Token',
                        type: 'string',
                        '@sensitive': true
                    }
                },
                required: ['token']
            }
        },
        required: ['title', 'id', 'namespace', 'space', 'authentication']
    }),
    getFormConfig: value({
        order: ['title', 'id', 'namespace', 'space', 'environment', 'authentication'],
        properties: {
            title: {
                widget: 'singleLineText',
                instructions: 'Human-readable identifier for use in the UI.'
            },
            namespace: {
                widget: 'singleLineText',
                instructions: 'A pascal-case prefix that will be added to types in your Contentful API.'
            },
            id: {
                widget: 'singleLineText',
                instructions: 'Unique identifier for use in the API and Schema.'
            },
            space: {
                widget: 'singleLineText',
                instructions: 'Unique identifier of the space e.g. "ahydyyckq8x6"'
            },
            environment: {
                widget: 'singleLineText',
                instructions: 'Optional identifier for the space environment e.g. (master, preview, etc.)'
            },
            authentication: {
                properties: {
                    token: {
                        widget: 'sensitiveField',
                        instructions: 'Content Delivery API Access Token for the Contentful Space'
                    }
                },
                order: ['token']
            }
        }
    }),
    getConfig(formData) {
        const config = {
            title: formData.title ?? 'Contentful',
            namespace: formData.namespace ?? 'Contentful',
            provider: 'contentful',
            serviceType: 'graphql',
            authenticationType: 'bearer',
            options: {
                endpoint: ['https://graphql.contentful.com/content/v1/spaces', formData.space]
                    .concat(formData.environment ? ['environments', formData.environment] : [])
                    .join('/'),
                space: formData.space,
                environment: formData.environment
            }
        };
        return updateAuthentication(config, formData, { type: 'bearer' });
    },
    isCompleteConfig: hasEveryKey(['authentication', 'options.space', 'options.endpoint']),
    getHealthCheck: getHealthCheck({ checkName: 'graphqlIntrospection' })
};
export default serviceProvider;
